import React from 'react';
import Home from './Components/Home/Home';


export default () => {
  return <Home name="Home Component" />;
};